import { Parameter } from "../models/Parameter";
import { PaginatedList } from "../helpers/PaginatedList";
import { MessagingHelper } from "../helpers/MessagingHelper";
import { APIService } from "./APIService";
import { CheckListModelDTO } from "../models/CheckListModel/CheckListModelDTO";
import { CreateCheckListModelDTO } from "../models/CheckListModel/CreateCheckListModelDTO";
import { EditCheckListModelDTO } from "../models/CheckListModel/EditCheckListModelDTO";

export class CheckListModelService {
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<CheckListModelDTO>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/ChecklistModel/GetAll`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {

        return new PaginatedList<CheckListModelDTO>(
          false,
          "Erro ao obter a informação sobre CheckLists",
        "",
        [],
        0
      );
    }
  }

  async Create(
    createCheckListModel: CreateCheckListModelDTO
  ): Promise<MessagingHelper<number>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/CheckListModel/Create`,
        {
          ...createCheckListModel,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
  
      return response.data;
    } catch (error) {
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para criar o modelo de checklist",
        0
      );
    }
  }

  async Edit(
    checklistUpdate: EditCheckListModelDTO
  ): Promise<MessagingHelper<null>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/CheckListModel/Edit`,
        { ...checklistUpdate },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para atualizar o modelo de checklist",
        null
      );
    }
  }

  async GetById(id: number): Promise<MessagingHelper<CheckListModelDTO | null>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/CheckListModel/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao obter o modelo de checklist",
        null
      );
    }
  }

  async Delete(id: number): Promise<MessagingHelper<null>> {
    try {
        const response = await APIService.Axios().put(
            `${APIService.GetURL()}/CheckListModel/Delete?id=${id}`,
            {}, // corpo vazio como definiste
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        return new MessagingHelper<null>(
            false,
            "Erro ao ligar ao servidor para eliminar o Modelo de Checklist",
            null
        );
    }
}

  
  
}


